var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"submit","disabled":!this.enabled,"aria-label":_vm.ariaLabel},domProps:{"innerHTML":_vm._s(_vm.label)}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecfa0414","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/cinquanta3/extensions/rubinred/forms/assets/js/components/FormSubmit.vue
// module id = oy53
// module chunks = 0